module.exports = __webpack_public_path__ + "static/media/Lens-Charm_HK.eab77f18.png";